<template>
  <div
    id="progress-banner-2025"
    aria-hidden="true"
  >
    <div class="banner">
      <div
        ref="banner-active"
        class="active"
        :style="`width: calc(${advance}%);`"
      >
        <div></div>
      </div>
      <div class="inactive">
        <div></div>
      </div>
    </div>
    <b-container class="text-center mb-2 info-container pb-0 pt-2 pl-2 pr-2 mt-0 border-top-0">
      <!-- <p
        class="h2"
        v-html="$t('c2025.progressbar.title')"
      ></p> -->
      <!-- For some reason $t is eating non-breaking spaces -->
      <p
        v-html="$t('c2025.progressbar.paragraph', {
          donations_sum: formatNumberAsCurrency(donationsSum),
          donations_count: formatNumber(donationsCount),
          max: formatNumberAsCurrency(max),
        // eslint-disable-next-line no-irregular-whitespace
        }).replace(/ €/g, ' €')"
      ></p>
    </b-container>
  </div>
</template>
<script setup>
import {
  computed, ref, defineProps, onMounted,
} from 'vue';

const props = defineProps({
  max: {
    type: Number,
    required: true,
  },
});

const donationsSum = ref(0);
const donationsCount = ref(0);

const fetchData = () => {
  fetch('https://soutenir.framasoft.org/campagne-fin-2025.json')
    .then(res => res.json())
    .then((data) => {
      if (donationsSum.value === 0) {
        donationsSum.value = data.total ?? 0;
        donationsCount.value = data.nb ?? 0;
      }
    })
      .catch((err) => { console.error(err) }); // eslint-disable-line
};

onMounted(() => {
  fetchData();
});

const advance = computed(() => Math.round(Math.min((Math.max(donationsSum.value, 10000) / props.max) * 100, 100)));

const currencyFormat = new Intl.NumberFormat(undefined, {
  style: 'currency', currency: 'EUR', roundingMode: 'ceil', maximumFractionDigits: 0,
});

const numberFormat = new Intl.NumberFormat(undefined, {
  style: 'decimal', currency: 'EUR', roundingMode: 'ceil', maximumFractionDigits: 0,
});

const formatNumberAsCurrency = number => currencyFormat.format(number);
const formatNumber = number => numberFormat.format(number);
</script>

<style lang="scss">
.info-container {
  background: var(--f-o6);
  border: 1px solid var(--f-o7);

  @media (min-width: 576px) {
    border-bottom-right-radius: 2rem;
    border-bottom-left-radius: 2rem;
  }

  &, & p {
    color: #FFF;
    font-size: 1.35rem;
  }
}
</style>
